import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { RouteComponentProps } from 'react-router';

import { getQueryParams } from '../../../utils/services/queryParams';
import { Grid, GridColumn, ModalTitle, ModalSubtitle } from '../../../core/components/styled';
import { createSuccessNotification, createErrorNotification } from '../../../core/services/createNotification';
import { Modal } from '../../../core/components';
// import pricingInfoIntialValueSelector from '../../services/pricingInfoIntialValueSelector';
import translate from '../../../core/services/translate';
import { AcceptPaymentForSelectedOnCallServiceForm } from '../forms';
import { ONCALL_SERVICE, LIMIT_PER_PAGE } from '../../constants';
import { AppState } from '../../../store';

interface RouteParams {
  token: string;
}

interface ComponentProps {
  pricingInfo: any;
  vendorId: number;
  updateAcceptSelectedOnCallPaymentServices(...args: any[]): any;
  onCancel(...args: any[]): any;
}

interface Props extends ComponentProps, RouteComponentProps<RouteParams> {
  workOrdersInfo: any;
  pricingInfo: any;
  selectedPaymentInfo: any;
  paymentInfo: any;
  isSaving: boolean;
}

class AcceptPaymentForSelectedOnCallModal extends PureComponent<Props> {
  onSubmit = async () => {
    const {
      vendorId,
      selectedPaymentInfo,
      location,
      onCancel,
      match: {
        params: { token },
      },
    } = this.props;
    const { page } = getQueryParams(location.search);
    const requestOnCallServicesObj: any = {};

    requestOnCallServicesObj.serviceType = ONCALL_SERVICE;
    requestOnCallServicesObj.paymentMethod = selectedPaymentInfo.paymentMethods;
    requestOnCallServicesObj.paymentId = selectedPaymentInfo.paymentId;
    requestOnCallServicesObj.rubiconInvoiceNo = selectedPaymentInfo.rubiconInvoiceNo;

    await this.props
      .updateAcceptSelectedOnCallPaymentServices(requestOnCallServicesObj, vendorId, token, page, LIMIT_PER_PAGE)
      .then(() => {
        createSuccessNotification(translate('opportunity.opportunitySave'));
        onCancel(true);
      })
      .catch(() => {
        createErrorNotification(translate('opportunity.opportunitySaveError'));
      });
  };

  stopPropagation = (event: any) => {
    event.preventDefault();
  };

  render() {
    const { isSaving, onCancel } = this.props;

    return (
      <Modal size="small" isLoading={isSaving}>
        <ModalTitle>{translate('payment.acceptPayment')}</ModalTitle>
        <ModalSubtitle />
        <Grid centered>
          <GridColumn size="8/12">
            <AcceptPaymentForSelectedOnCallServiceForm {...this.props} onSubmit={this.onSubmit} onCancel={onCancel} />
          </GridColumn>
        </Grid>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('acceptPaymentForSelectedOnCallService');

const mapStateToProps = (state: AppState, ownProps: ComponentProps) => ({
  workOrdersInfo: state.payments.onCallServices.workOrdersInfo,
  pricingInfo: state.payments.onCallServices.pricingInfo,
  selectedPaymentInfo: formSelector(state, `pricingInfo.settings${ownProps.pricingInfo.rubiconInvoiceNo}`),
  paymentInfo: state.payments.onCallServices.paymentInfo,
  isSaving: state.payments.onCallServices.isSaving,
});

export default connect(mapStateToProps, undefined)(AcceptPaymentForSelectedOnCallModal);
